module.exports = __webpack_public_path__ + "media/svg-new/scale-f83b47c3.svg";